// Demo dataset used as a fallback for the preview when the live Apps Script API
// is unreachable (CORS) or returns a non-matching shape.
// NOTE: This is DEMO data for preview purposes only. The real business logic
// (category, blockers, authorizations, signatures) is computed server-side by
// the Apps Script API — this frontend only displays results.

export const CATEGORY_LABELS = { 1: 'Catégorie 1', 2: 'Catégorie 2', 3: 'Catégorie 3' };

export const STATUS_LABELS = {
  brouillon: 'Brouillon',
  soumise: 'Soumise',
  analyse_risques: 'Analyse des risques',
  approbation: 'En approbation',
  implementation: 'Implémentation',
  pret_cloture: 'Prêt à clôturer',
  cloturee: 'Clôturée',
  annulee: 'Annulée',
};

export const ALERT_LEVELS = {
  none: { label: 'Normal', color: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300' },
  info: { label: 'À surveiller', color: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300' },
  warning: { label: 'Attention', color: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300' },
  critical: { label: 'Urgent', color: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300' },
};

const now = new Date();
const daysAgo = (n) => new Date(now.getTime() - n * 86400000).toISOString();
const daysAhead = (n) => new Date(now.getTime() + n * 86400000).toISOString();

export const demoMocs = [
  {
    id: 'MOC-2026-0142', title: 'Remplacement du convoyeur ligne cuisson 2',
    site: 'Cimenterie Bouskoura', requester: 'khalifa.belkhiter@gmail.com',
    category: 2, nature: 'Permanent', status: 'implementation', alert: 'warning',
    createdAt: daysAgo(24), updatedAt: daysAgo(2), dueAt: daysAhead(10),
    department: 'Maintenance', pssrRequired: true, pssrStatus: 'en_attente',
    currentSituation: "Convoyeur à bande d'origine, usure avancée des rouleaux, arrêts fréquents.",
    futureSituation: "Nouveau convoyeur renforcé avec système de détection de déchirure.",
    modificationTypes: ['Équipement', 'Procédé'],
    openActions: 2, lateActions: 1, ageDays: 24,
  },
  {
    id: 'MOC-2026-0139', title: 'Modification du point d\'injection alternatif',
    site: 'Geocycle Meknès', requester: 'a.tazi@geocycle.com',
    category: 1, nature: 'Permanent', status: 'analyse_risques', alert: 'critical',
    createdAt: daysAgo(12), updatedAt: daysAgo(1), dueAt: daysAhead(4),
    department: 'Procédé', pssrRequired: true, pssrStatus: 'en_attente',
    currentSituation: "Injection combustibles alternatifs au précalcinateur uniquement.",
    futureSituation: "Ajout d'un second point d'injection en tête de four.",
    modificationTypes: ['Procédé', 'Matière première', 'Sécurité'],
    openActions: 4, lateActions: 2, ageDays: 12,
  },
  {
    id: 'MOC-2026-0135', title: 'Changement fournisseur additif broyage',
    site: 'Cimenterie Bouskoura', requester: 'm.idrissi@lafarge.com',
    category: 3, nature: 'Permanent', status: 'approbation', alert: 'info',
    createdAt: daysAgo(31), updatedAt: daysAgo(5), dueAt: daysAhead(20),
    department: 'Qualité', pssrRequired: false, pssrStatus: null,
    currentSituation: "Additif de mouture fournisseur A.",
    futureSituation: "Additif équivalent fournisseur B, coût réduit.",
    modificationTypes: ['Matière première'],
    openActions: 1, lateActions: 0, ageDays: 31,
  },
  {
    id: 'MOC-2026-0128', title: 'Bypass temporaire filtre à manches',
    site: 'Geocycle Meknès', requester: 'khalifa.belkhiter@gmail.com',
    category: 2, nature: 'Temporaire', status: 'pret_cloture', alert: 'warning',
    createdAt: daysAgo(48), updatedAt: daysAgo(3), dueAt: daysAhead(2),
    department: 'Environnement', pssrRequired: true, pssrStatus: 'valide',
    currentSituation: "Filtre à manches en service normal.",
    futureSituation: "Bypass temporaire 15 jours pour maintenance.",
    modificationTypes: ['Équipement', 'Environnement'],
    openActions: 0, lateActions: 0, ageDays: 48, temporaryEndsAt: daysAhead(2),
  },
  {
    id: 'MOC-2026-0121', title: 'Mise à jour automate salle de contrôle',
    site: 'Cimenterie Bouskoura', requester: 'r.benali@lafarge.com',
    category: 2, nature: 'Urgent', status: 'soumise', alert: 'critical',
    createdAt: daysAgo(3), updatedAt: daysAgo(1), dueAt: daysAhead(1),
    department: 'Automatisme', pssrRequired: true, pssrStatus: 'en_attente',
    currentSituation: "Automate version obsolète, faille de sécurité connue.",
    futureSituation: "Migration firmware avec correctif éditeur.",
    modificationTypes: ['Automatisme', 'Sécurité'],
    openActions: 3, lateActions: 0, ageDays: 3,
  },
  {
    id: 'MOC-2025-0098', title: 'Réaménagement zone stockage clinker',
    site: 'Cimenterie Bouskoura', requester: 'm.idrissi@lafarge.com',
    category: 3, nature: 'Permanent', status: 'cloturee', alert: 'none',
    createdAt: daysAgo(210), updatedAt: daysAgo(120), dueAt: daysAgo(130),
    department: 'Logistique', pssrRequired: false, pssrStatus: null,
    currentSituation: "Stockage clinker à ciel ouvert.",
    futureSituation: "Hall couvert avec extraction automatisée.",
    modificationTypes: ['Infrastructure'],
    openActions: 0, lateActions: 0, ageDays: 210,
  },
];

export const demoActions = [
  { id: 'ACT-501', mocId: 'MOC-2026-0142', title: 'Consignation électrique ligne 2', owner: 'khalifa.belkhiter@gmail.com', due: daysAgo(1), status: 'en_retard', blocking: true, source: 'Analyse des risques' },
  { id: 'ACT-502', mocId: 'MOC-2026-0142', title: 'Formation opérateurs nouveau convoyeur', owner: 'r.benali@lafarge.com', due: daysAhead(5), status: 'ouverte', blocking: false, source: 'Implémentation' },
  { id: 'ACT-511', mocId: 'MOC-2026-0139', title: 'Étude ATEX second point injection', owner: 'a.tazi@geocycle.com', due: daysAgo(2), status: 'en_retard', blocking: true, source: 'PSSR' },
  { id: 'ACT-512', mocId: 'MOC-2026-0139', title: 'Mise à jour plan HAZOP', owner: 'khalifa.belkhiter@gmail.com', due: daysAhead(3), status: 'ouverte', blocking: true, source: 'Analyse des risques' },
  { id: 'ACT-521', mocId: 'MOC-2026-0121', title: 'Sauvegarde configuration automate', owner: 'r.benali@lafarge.com', due: daysAhead(1), status: 'ouverte', blocking: true, source: 'Implémentation' },
];

export const demoValidations = [
  { id: 'MOC-2026-0135', title: 'Changement fournisseur additif broyage', role: 'Approbateur Qualité', requestedAt: daysAgo(5), category: 3, status: 'approbation' },
  { id: 'MOC-2026-0139', title: 'Modification du point d\'injection alternatif', role: 'Pilote MOC', requestedAt: daysAgo(1), category: 1, status: 'analyse_risques' },
];

export const demoNotifications = [
  { id: 'N1', type: 'action', title: 'Action en retard', body: 'ACT-501 — Consignation électrique ligne 2 est en retard.', mocId: 'MOC-2026-0142', read: false, at: daysAgo(1) },
  { id: 'N2', type: 'validation', title: 'Validation requise', body: 'MOC-2026-0139 attend votre décision Pilote.', mocId: 'MOC-2026-0139', read: false, at: daysAgo(1) },
  { id: 'N3', type: 'pssr', title: 'PSSR en attente', body: 'Le PSSR de MOC-2026-0121 doit être planifié.', mocId: 'MOC-2026-0121', read: false, at: daysAgo(2) },
  { id: 'N4', type: 'info', title: 'MOC clôturée', body: 'MOC-2025-0098 a été clôturée avec succès.', mocId: 'MOC-2025-0098', read: true, at: daysAgo(120) },
];

export const demoPssr = [
  {
    id: 'PSSR-2026-042', mocId: 'MOC-2026-0142', title: 'PSSR — Convoyeur ligne cuisson 2',
    site: 'Cimenterie Bouskoura', status: 'en_attente', plannedAt: daysAhead(3),
    committee: [
      { name: 'Khalifa Belkhiter', role: 'Chef de projet', signed: true, decision: 'oui' },
      { name: 'R. Benali', role: 'Responsable maintenance', signed: false, decision: null },
      { name: 'A. Tazi', role: 'HSE', signed: false, decision: null },
    ],
    checklist: [
      { id: 'c1', theme: 'Équipement', question: 'Les équipements sont-ils installés selon les spécifications ?', answer: 'oui' },
      { id: 'c2', theme: 'Équipement', question: 'Les protections mécaniques sont-elles en place ?', answer: 'non', actionCreated: 'ACT-502' },
      { id: 'c3', theme: 'Sécurité', question: 'Les consignations sont-elles vérifiées ?', answer: 'non', actionCreated: 'ACT-501' },
      { id: 'c4', theme: 'Formation', question: 'Les opérateurs ont-ils été formés ?', answer: null },
      { id: 'c5', theme: 'Documentation', question: 'Les procédures sont-elles à jour ?', answer: 'oui' },
    ],
    authorization: { decisions: [null, null, null], blockingOpen: true, canAuthorize: false },
  },
];

export const demoDashboard = {
  kpis: {
    total: 6, open: 4, cat1: 1, cat2: 3, temporary: 1, urgent: 2,
    pssrPending: 3, actionsOpen: 5, actionsLate: 3, avgDelayDays: 18, oldMocs: 2,
  },
  byStatus: [
    { name: 'Soumise', value: 1 }, { name: 'Analyse', value: 1 },
    { name: 'Approbation', value: 1 }, { name: 'Implémentation', value: 1 },
    { name: 'Prêt clôture', value: 1 }, { name: 'Clôturée', value: 1 },
  ],
  byCategory: [
    { name: 'Cat. 1', value: 1 }, { name: 'Cat. 2', value: 3 }, { name: 'Cat. 3', value: 2 },
  ],
  trend: [
    { name: 'Jan', créées: 3, clôturées: 2 }, { name: 'Fév', créées: 5, clôturées: 3 },
    { name: 'Mar', créées: 4, clôturées: 4 }, { name: 'Avr', créées: 6, clôturées: 5 },
    { name: 'Mai', créées: 5, clôturées: 6 }, { name: 'Juin', créées: 6, clôturées: 4 },
  ],
};

const DEMO_PDF = 'data:application/pdf;base64,JVBERi0xLjEKMSAwIG9iajw8L1R5cGUvQ2F0YWxvZy9QYWdlcyAyIDAgUj4+ZW5kb2JqCjIgMCBvYmo8PC9UeXBlL1BhZ2VzL0tpZHNbMyAwIFJdL0NvdW50IDE+PmVuZG9iagozIDAgb2JqPDwvVHlwZS9QYWdlL1BhcmVudCAyIDAgUi9NZWRpYUJveFswIDAgMzAwIDIwMF0vQ29udGVudHMgNCAwIFIvUmVzb3VyY2VzPDwvRm9udDw8L0YxIDUgMCBSPj4+Pj4+ZW5kb2JqCjQgMCBvYmo8PC9MZW5ndGggNjA+PnN0cmVhbQpCVCAvRjEgMTQgVGYgNDAgMTAwIFRkIChBbmFseXNlIHJpc3F1ZXMgLSBkZW1vKSBUaiBFVAplbmRzdHJlYW0gZW5kb2JqCjUgMCBvYmo8PC9UeXBlL0ZvbnQvU3VidHlwZS9UeXBlMS9CYXNlRm9udC9IZWx2ZXRpY2E+PmVuZG9iagp0cmFpbGVyPDwvUm9vdCAxIDAgUj4+CiUlRU9G';
const DEMO_PNG = 'data:image/png;base64,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';

export const documentsByMoc = {
  'MOC-2026-0142': [
    { id: 'D1', name: 'Analyse_risques_convoyeur.pdf', category: 'Analyse des risques', type: 'pdf', size: '1.2 Mo', version: 2, archived: false, at: daysAgo(6), _preview: DEMO_PDF },
    { id: 'D2', name: 'Schema_installation.png', category: 'Plans', type: 'image', size: '640 Ko', version: 1, archived: false, at: daysAgo(10), _preview: DEMO_PNG },
    { id: 'D3', name: 'Ancienne_procedure.pdf', category: 'Procédure', type: 'pdf', size: '820 Ko', version: 1, archived: true, at: daysAgo(20), _preview: DEMO_PDF },
  ],
};

export const closureChecklist = [
  'Toutes les actions sont clôturées',
  'Les documents finaux sont archivés',
  'Le PSSR est validé (si requis)',
  'Les procédures opératoires sont mises à jour',
  'Les formations nécessaires sont réalisées',
  'Les modifications sont reflétées dans les plans/P&ID',
  'Les parties prenantes sont informées',
  'Le retour d\'expérience est documenté',
  'La modification temporaire est retirée (si applicable)',
];
